import { useState, useCallback } from 'react';

export interface FormSubmitProps {
  onSubmit: (data: any) => Promise<void>;
  onClose: () => void;
  onSuccess?: () => void;
  isLoading?: boolean;
}

export interface FormSubmissionState {
  isSubmitting: boolean;
  error: string | null;
  hasSubmitted: boolean;
}

export const useFormSubmission = () => {
  const [state, setState] = useState<FormSubmissionState>({
    isSubmitting: false,
    error: null,
    hasSubmitted: false
  });

  const handleSubmit = useCallback(async (
    submitFn: () => Promise<void>,
    onSuccess?: () => void,
    onClose?: () => void
  ) => {
    setState(prev => ({ ...prev, isSubmitting: true, error: null }));
    
    try {
      console.log('Form submission starting...');
      await submitFn();
      console.log('Form submission completed successfully');
      
      setState(prev => ({ ...prev, hasSubmitted: true }));
      
      // Call onSuccess first if provided
      if (onSuccess) {
        console.log('Calling onSuccess callback');
        onSuccess();
      }
      
      // Always call onClose after successful submission
      if (onClose) {
        console.log('Calling onClose callback');
        onClose();
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setState(prev => ({ 
        ...prev, 
        error: error instanceof Error ? error.message : 'Erro ao salvar'
      }));
      // Don't call onClose on error - keep modal open to show error
    } finally {
      setState(prev => ({ ...prev, isSubmitting: false }));
    }
  }, []);

  const resetState = useCallback(() => {
    setState({
      isSubmitting: false,
      error: null,
      hasSubmitted: false
    });
  }, []);

  return {
    ...state,
    handleSubmit,
    resetState
  };
};
